(function () {
  const sections = document.querySelectorAll('[data-recipes-how]');
  if (!sections.length) return;

  sections.forEach((section) => {
    section.classList.add('frw-js');

    const revealItems = section.querySelectorAll('.frw-reveal, .frw-reveal-scale, .frw-fact');
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('frw-is-visible');
        observer.unobserve(entry.target);
      });
    }, {
      threshold: 0.16,
      rootMargin: '0px 0px -48px 0px'
    });

    revealItems.forEach((item, index) => {
      if (!item.style.getPropertyValue('--frw-delay')) {
        item.style.setProperty('--frw-delay', `${index * 80}ms`);
      }
      observer.observe(item);
    });
  });
})();
